import React from "react";
import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import {
  useSnapshotExtension,
  useSnapshotExtensionTop,
} from "../../../common/controls";
import { FormControl } from "@mui/material";

type CollectiveManagementSocietyViewProps = {
  snapshotData: any;
  // Propagated from the top-level snapshot view so nested tables can resolve
  // the snapshot-scoped file-download endpoint (/<snapshotEntityName>.data/
  // <snapshotRecordId>/<fileUuid>). Both are optional at the type level but
  // required at runtime for the download / view affordances to work.
  snapshotEntityName?: string;
  snapshotRecordId?: string;
};

export const CollectiveManagementSocietyView: React.FC<
  CollectiveManagementSocietyViewProps
> = ({ snapshotData }) => {
  const { langStore } = useRootStore();
  const renderExtensionTop = useSnapshotExtensionTop(
    "CollectiveManagementSociety"
  );
  const renderExtension = useSnapshotExtension("CollectiveManagementSociety");

  return (
    <>
      {renderExtensionTop ? renderExtensionTop(snapshotData) : null}
      <FormControl fullWidth>
        <ShowMultiLine
          label={langStore.CollectiveManagementSocietyNameLabel}
          value={String(snapshotData?.name ?? "")}
        />
        <ShowMultiLine
          label={langStore.CollectiveManagementSocietyAcronymLabel}
          value={String(snapshotData?.acronym ?? "")}
        />
      </FormControl>
      {renderExtension ? renderExtension(snapshotData) : null}
    </>
  );
};
